import { RuleId } from '@wix/a11y-rules';
export const DISABLED_SITE_RULES = [];

// Defines the rendering order for site-level rules.
export const SITE_LEVEL_RULE_ORDER = [RuleId.VISUAL_INDICATORS, RuleId.SKIP_TO_MAIN_CONTENT, RuleId.SITE_LANGUAGE, RuleId.DOM_ORDER];
//# sourceMappingURL=constants.js.map